import React from 'react';
import styled from '@emotion/styled';

import mediaqueries from '@styles/media';

import { Icon } from '@types';

const Logo: Icon = ({ fill = 'white' }) => {
	return (
		<LogoContainer>
			<svg width="107" height="125" viewBox="0 0 450 500" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M150.28 315.473L249 284V351H201.454L184.357 351H127L150.28 315.473Z" fill="#22559C" />
				<rect x="254" y="39" width="31" height="260" fill="#EDE862" />
				<rect x="253.708" y="284.309" width="30.603" height="38.5005" fill="#EDE862" />
				<rect
					width="188.465"
					height="45.1683"
					transform="matrix(0.707566 0.706647 -0.706679 0.707535 284.86 291.93)"
					fill="#EDE862"
				/>
				<path d="M285.299 8.88062V39.4836H254.696L285.299 8.88062Z" fill="#EDE862" />
				<rect x="214.222" y="0.984192" width="36.53" height="38.5005" fill="#F27370" />
				<path d="M214.221 1.4801V39.9807H175.72L214.221 1.4801Z" fill="#FA9856" />
				<path d="M249 40.0839L249.676 1L284.671 1.60511L249 40.0839Z" fill="#F27370" />
				<rect x="173.748" y="44.426" width="75.0305" height="120.438" fill="#22559C" />
				<rect x="211.258" y="163.872" width="37.5172" height="134.258" fill="#22559C" />
				<path d="M95.7572 298.134H170.784L72.0646 457.072H3.94821L95.7572 298.134Z" fill="#22559C" />
				<path
					d="M144.627 298.782L220.342 297.964L382.227 458.753L308.776 459.547L144.627 298.782Z"
					fill="#22559C"
				/>
				<path
					d="M173.16 162.831L212.743 162.884L133.76 303.599L94.6689 298.563L173.16 162.831Z"
					fill="#22559C"
				/>
			</svg>
		</LogoContainer>
	);
};

export default Logo;

const LogoContainer = styled.div`
	.Logo__Mobile {
		display: none;
	}

	${mediaqueries.tablet`
    .Logo__Desktop {
      display: none;
    }
    
    .Logo__Mobile{
      display: block;
    }
  `};
`;
